import { Component } from 'react';

import Seo from '../../constants/seo'

class Title extends Component {
    
    componentDidMount() {

        document.title = `${Seo.baseTitle} / ${this.props.text}`

    }

    render() {
        return null
    }
}

export default Title